import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Scissors, Hammer, Flower2, Leaf, Droplets, Truck } from 'lucide-react';
import { GrassDivider } from './SectionDivider';
export function ServicesSection() {
  const services = [{
    title: 'Grass Cutting & Trimming',
    description: 'A perfectly manicured lawn that makes you proud every time you come home',
    icon: Scissors
  }, {
    title: 'Hardscape',
    description: 'Beautiful patios, walkways & retaining walls that add real value to your home',
    icon: Hammer
  }, {
    title: 'Flower Beds',
    description: 'Vibrant, clean, picture-perfect beds that boost your curb appeal instantly',
    icon: Flower2
  }, {
    title: 'Mulching',
    description: 'Fresh, rich mulch that protects your plants and makes everything look polished',
    icon: Leaf
  }, {
    title: 'Gutter Cleaning',
    description: 'Peace of mind knowing your home is protected from water damage',
    icon: Droplets
  }, {
    title: 'Junk Removal',
    description: 'A clean, clutter-free property — haul it away and breathe easy',
    icon: Truck
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-brand-offWhite relative overflow-hidden" data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-225">
        <div className="text-center mb-16" data-id="element-226">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-brand-black mb-4" data-id="element-227">
            Everything Your Property Needs
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-brand-gold font-medium" data-id="element-228">
            All In One Place
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-229">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={cardVariants} className="group p-8 rounded-2xl bg-white border border-brand-gold/10 hover:border-brand-gold/40 hover:shadow-xl transition-all duration-300 relative overflow-hidden" data-id="element-230">
                {/* Top Border Accent */}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-brand-gold transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out" data-id="element-231"></div>

                <div className="w-16 h-16 rounded-full bg-brand-gold/10 text-brand-gold flex items-center justify-center mb-6 group-hover:bg-brand-gold group-hover:text-black transition-all duration-500 shadow-sm" data-id="element-232">
                  <Icon size={28} data-id="element-233" />
                </div>
                <h3 className="text-xl font-bold text-brand-black mb-3 font-serif" data-id="element-234">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-235">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>

      {/* Grass Pattern at bottom - Transition to TestimonialsSection (bg-brand-dark) */}
      <GrassDivider fill="#111111" position="bottom" className="opacity-100" data-id="element-236" />
    </section>;
}